import {
  type GameEngineConfig,
  GameEngineManager,
} from "./game-engine-manager";

type GameEngineInstance = WithNonNullable<
  GameEngineManager,
  // mark all the null-initialized systems as required
  | "gameStore"
  | "voxelTerrain"
  | "gameLoop"
  | "renderer"
  | "miningSystem"
  | "movementSystem"
  | "inputManager"
  | "grenadeSystem"
>;

/**
 * Singleton instance of GameEngineManager
 */
export let GameEngine = undefined as unknown as GameEngineInstance;

export async function initGameEngine(config: GameEngineConfig) {
  GameEngine = new GameEngineManager() as GameEngineInstance;
  await GameEngine.initialize(config);
}
export function shutdownGameEngine() {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (GameEngine) {
    GameEngine.shutdown();
    GameEngine = undefined as unknown as GameEngineInstance;
  }
}
